import { Link, Text } from '@chakra-ui/react';

import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from '@m/constants/Contacts';

export function TermsAndConditionsFooter() {
  return (
    <Text
      fontSize="14px"
      color="rgba(0,0,0,0.6)"
      mt={3}
      lineHeight="1.71428571"
      letterSpacing="0.01em"
    >
      By tapping Pay, you agree to the{' '}
      <Link
        href={TERMS_OF_SERVICE_URL}
        target="_blank"
        rel="noopener noreferrer"
        color="text.primary"
        fontWeight="semibold"
        textDecoration="none"
      >
        Terms of Service
      </Link>{' '}
      and{' '}
      <Link
        href={PRIVACY_POLICY_URL}
        target="_blank"
        rel="noopener noreferrer"
        color="text.primary"
        fontWeight="semibold"
        textDecoration="none"
      >
        Data and Privacy Policy
      </Link>
      <br />
      Payment method will be saved to your account for future use, manage and edit your account
      information anytime
    </Text>
  );
}
